import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Row,
  Col,
  Button,
  Table,
  ButtonGroup,
  Badge,
  ButtonDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Input,
  Label
} from "reactstrap";
import Select from "react-select";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, filterHelper, uiHelper, constant } from "../helpers";
import { TextFilter, SelectFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import { Link } from "react-router-dom";
import classnames from "classnames";

const getProducts = () => api.fetch('Reference/Products').then(response => {
  return {
    productList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
  };
}).catch(x => console.error(x));
const getFacilities = () => api.fetch('Reference/Facilities').then(response => {
  return {
    facilityList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
  };
}).catch(x => console.error(x));

export default class COAProduct extends Component {
  static displayName = COAProduct.name;
  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,
      productList: [],
      facilityList: [],
      dropdownOpen: false,
      viewOnly: props.viewOnly ? props.viewOnly : false,
      prestineProduct: null,
      editCoaProduct: null,
    };

    this.refreshList = this.refreshList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
  }

  componentDidMount() {
    Promise.all([getProducts(), getFacilities()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, ()=>this.refreshList());
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Admin/COAProducts", payload)
      .then(response => {
        if (response.data) {
          let list = _.map(response.data.dataSource, l => {
            l.editing = false;
            l.product = uiHelper.resolveValue(null, l.productId, l.productName);
            l.facility = uiHelper.resolveValue(null, l.facilityId, l.facilityName);
            l.facilitySample = uiHelper.resolveValue(null, l.facilitySampleId, l.facilitySampleName);

            return l;
          });

          this.setState({
            ...resolvedSort,
            pagedList: {
              list: list,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
          });
        }
      })
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters },
      () => { this.refreshList(null, null, filters, 1) }
    );
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
    });
  }

  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen })
  }
  onInputChange(event, id, fieldName) {
    let list = this.state.pagedList.list.slice();
    const index = _.findIndex(list, l => l.id === id);
    list[index][fieldName] = event.target ? event.target.value : event;

    this.setState({
      pagedList: { ...this.state.pagedList, list: list }
    })
  }
  onCheckBoxChange(id, fieldName) {
    let list = this.state.pagedList.list.slice();
    const index = _.findIndex(list, l => l.id === id);
    list[index][fieldName] = !list[index][fieldName];
    this.setState({
      pagedList: { ...this.state.pagedList, list: list }
    });
  }

  onEdit(id) {
    let list = this.state.pagedList.list.slice();
    const index = _.findIndex(list, l => l.id === id);
    let prestine = Object.assign({}, list[index]);
    list[index].editing = true;

    this.setState({
      pagedList: { ...this.state.pagedList, list: list },
      prestineProduct: prestine
    })
  }
  onCancelEdit(id) {
    let list = this.state.pagedList.list.slice();
    const index = _.findIndex(list, l => l.id === id);
    list[index] = Object.assign({}, this.state.prestineProduct);
    list[index].editing = false;

    this.setState({
      pagedList: { ...this.state.pagedList, list: list },
      prestineProduct: null
    })
  }
  onSave(id) {
    let list = this.state.pagedList.list.slice();
    const item = _.find(list, l => l.id === id);
    let payload = {
      Id: item.id,
      FacilityId: item.facility ? item.facility.value : null,
      FacilitySampleId: item.facilitySample ? item.facilitySample.value : null,
      FacilitySampleName: item.facilitySample ? item.facilitySample.label : null,
      Unit: item.unit,
      ProductId: item.product ? item.product.value : null,
      IncludeInCOAReport: item.includeInCOAReport
    }
    api.post("admin/SaveCOAProduct", payload)
      .then(r => {
        if (r && r.data && r.data.success) {
          this.refreshList();
          Alert.success("Product details was saved.")
        } else {
          Alert.error(r.data.message || "An error occurred. Product cannot be saved at this time.")
        }
      }).catch(error => {
        Alert.error("Something went wrong. Product details cannot be saved at this time.")
      });
  }
  render() {
    const { dropdownOpen } = this.state;
    return (
      <div className="ml-4 mr-4">
        <Row className={"p-2"}>
          <Col>
            <h4>COA Products</h4>
          </Col>
        </Row>

        <Row className="rowSpacing cursor">
          <Col>
            <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor pl-1 pr-1">
              <Col xs="3">
                <TextFilter
                  filterName="name"
                  displayName=" Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="productId"
                  displayName="CBDMD Product"
                  isSingleSelect={true}
                  options={this.state.productList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "productId",
                    this.state.filters
                  )}
                />
              </Col>

              <Col xs="3">
                <SelectFilter
                  filterName="facilityId"
                  displayName="Facility"
                  isSingleSelect={true}
                  options={this.state.facilityList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "facilityId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <SelectFilter 
                  filterName="includeInCOAReport"
                  displayName="Included in COA Report Only"
                  isSingleSelect={true}
                  options={constant.activeList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "includeInCOAReport",
                    this.state.filters
                  )}
                />
              </Col>
            </FilterSet>
          </Col>
        </Row>

        <Row className="d-flex flex-row mt-2">
          <Col>
            <Table size="sm" responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>CBDMD Product</th>
                  <th>Include In Report</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map(e => (
                    <tr key={e.id}>
                      <td>
                        <div>
                          {e.facilitySample && e.facilitySample.label}
                         </div>
                         <div>
                            <span className="boldText mr-2">Sample Id:</span>
                            <span>{e.facilitySample.value}</span>
                         </div>
                        <div>
                            <span className="boldText mr-2">Facility:</span>
                            <span className="boldText mr-2">{e.facility && e.facility.label}</span>
                         </div>
                      </td>
                      {e.editing ? (
                        <Fragment>
                          <td>
                            <Select
                              options={this.state.productList}
                              value={e.product || null}
                              onChange={(evt) => this.onInputChange(evt, e.id, "product")}
                            />
                          </td>
                          <td>
                            <Label for="includeInCOAReport">
                              <input
                                type="checkbox"
                                className="mr-2"
                                id="includeInCOAReport"
                                name="includeInCOAReport"
                                checked={e.includeInCOAReport}
                                value={e.includeInCOAReport}
                                onClick={() => this.onCheckBoxChange(e.id, "includeInCOAReport")}
                              />
                            Include In COA Report?
                          </Label>

                          </td>
                          <td>
                            <ButtonGroup>
                              <Button className={"cbdmdSecondary buttonGroupSpacing"} size="sm" title={"Cancel Edit"} onClick={() => this.onCancelEdit(e.id)}>
                                <FontAwesomeIcon icon="reply" />
                              </Button>
                              <Button className={"cbdmdPrimary buttonGroupSpacing"} size="sm" title={"Save Details"} onClick={() => this.onSave(e.id)}>
                                <FontAwesomeIcon icon="save" />
                              </Button>
                            </ButtonGroup>
                          </td>
                        </Fragment>
                      ) : (
                          <Fragment>
                            <td>{e.product && e.product.label}</td>
                            <td>
                              <FontAwesomeIcon className={e.includeInCOAReport ? "successText" : "cbdmdDangerText" } icon={e.includeInCOAReport ? "check-circle" : "times" } />
                            </td>
                            <td>
                              <ButtonGroup>
                                <Button className={"cbdmdPrimary buttonGroupSpacing"} size="sm" title={"Edit Details"} onClick={() => this.onEdit(e.id) }>
                                  <FontAwesomeIcon icon="edit" />
                                </Button>
                              </ButtonGroup>
                            </td>
                          </Fragment>
                        )}
                    </tr>
                  ))) : (<tr>
                      <td>
                          No Records available
                      </td>
                  </tr>)}
              </tbody>
            </Table>
            <Pager {...this.state.pagedList} callBack={this.setPage} />
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/COAProduct.js